<template>
    <form-wrapper
        class="third-opportunities-form"
        @catch-errors="catchErrors"
        :linkedForm="linkedForm"
        :redirection="redirectionTo"
        :store="store"
        :current="current"
        :deletionConfirmation="hasItemCreated"
        :labelSaveAndAction="saveAndLabelAction"
    >
        <template slot="title">{{ formTitle }}</template>

        <!-- THE OPPORTUNITY -->
        <form-fields-wrapper
            field="opportunity"
            :toggleAllowed="false"
            :title="$t.__('pages.forms.ThirdOpportunitiesForm.opportunity')"
        >
            <form-fields-opportunity :currentStore="current" :error="error.errors" ref="main" />
        </form-fields-wrapper>

        <!-- THE COMPANY -->
        <form-fields-wrapper
            :field="relatedThird"
            :toggleAllowed="false"
            :title="relatedThirdTitle[relatedThird]"
            switchAllowed
            @switch-form-field="switchFomField()"
        >
            <form-fields-third-to-add
                :currentStore="current"
                lightForm
                :third="relatedThird"
                ref="formFieldsThirdToAdd"
            />
        </form-fields-wrapper>

        <!-- THE CONTACTS -->
        <form-fields-wrapper
            v-if="relatedThird === 'company'"
            :field="'contact'"
            :activeFields="['contact']"
            :toggleAllowed="true"
            :title="$t.__('common.labels.contact')"
        >
            <form-fields-contact-to-add
                :disabled="!hasCompany"
                :goBackMsg="goBackMsg"
                :currentStore="current"
                :addToListWording="addToContactListWording"
                lightForm
                mode="manual"
            />
        </form-fields-wrapper>

        <!-- CUSTOM FIELDS -->
        <form-fields-wrapper
            field="custom-fields"
            :toggleAllowed="true"
            :activeFields="['custom-fields']"
            :title="$t.__('pages.forms.ThirdOpportunitiesForm.opportunity_custom_fields')"
        >
            <form-fields-custom-fields
                :currentStore="current"
                :error="error.errors"
                :currentCustomfields="getCustomFields"
                ref="custom-fields"
            />
        </form-fields-wrapper>
    </form-wrapper>
</template>

<script>
import FormFieldsContactToAdd from 'vcomponents/thirds/thirdscomponents/FormFieldsContactToAdd.vue';
import FormFieldsThirdToAdd from 'vcomponents/thirds/thirdscomponents/FormFieldsThirdToAdd.vue';
import FormFieldsOpportunity from 'vcomponents/thirds/thirdscomponents/FormFieldsOpportunity.vue';
import FormFieldsCustomFields from 'vcomponents/thirds/thirdscomponents/FormFieldsCustomFields.vue';
import FormFieldsWrapper from 'vcomponents/forms/FormFieldsWrapper.vue';
import FormWrapper from 'vcomponents/forms/FormWrapper.vue';
import opportunityModule from 'stores/forms/opportunity';

export default {
    props: {
        linkedForm: {
            type: Object,
            required: false,
            default: null,
        },
    },
    components: {
        FormFieldsThirdToAdd,
        FormFieldsContactToAdd,
        FormFieldsCustomFields,
        FormFieldsOpportunity,
        FormFieldsWrapper,
        FormWrapper,
    },
    data() {
        return {
            current: 'opportunityForm',
            store: opportunityModule,
            redirectionTo: 'opportunity.overview.activity',
            formTitle: this.$l10n.__('Créer une nouvelle opportunité'),
            saveAndLabelAction: this.$l10n.__('Enregistrer et créer une autre opportunité'),
            addToContactListWording: {
                added: this.$l10n.__('L’OPPORTUNITÉ'),
                search: this.$l10n.__('Lier à l’opportunité'),
                add: this.$l10n.__('Créer un nouveau contact'),
            },
            error: {},
            hasContacts: false,
            goBackMsg: this.$l10n.__("Retour à l'opportunité"),
            relatedThird: 'company',
            relatedThirdTitle: {
                company: this.$l10n.__('La société'),
                individual: this.$l10n.__('Particulier'),
            },
        };
    },
    created() {
        //Avoid duplication of store
        if (!this.$store.state.opportunity?.id) {
            this.$store.registerModule(this.current, this.store);
        }
    },
    updated() {
        /**
         * Scroll until contact form fields
         */
        let container = document.querySelector('#form-field-contact');
        if (this.linkedForm && this.linkedForm.name === 'contact' && !this.mounted) {
            document.querySelector('#sellsy_app').scrollTo({
                top: container.offsetTop + container.scrollHeight,
                behavior: 'smooth',
            });
            window.setTimeout(() => {
                this.mounted = true;
            }, 250);
        }
    },
    beforeDestroy() {
        this.$store.unregisterModule(this.current);
    },
    computed: {
        getCustomFields() {
            return this.linkedForm?.state?.customFields ? this.linkedForm.state.customFields : [];
        },
        hasCompany() {
            return (
                this.$store.getters[`${this.current}/getThirdName`] !== '' &&
                this.$store.getters[`${this.current}/getThirdType`] !== 'individuals'
            );
        },
        hasContact() {
            return this.$store.getters[`${this.current}/getContacts`].length > 0;
        },
        /**
         * Check if new third or it has unregistered contacts, then display warning message if it's the case.
         */
        hasItemCreated() {
            return this.$store.getters[`${this.current}/getHasNewItems`];
        },
    },
    methods: {
        /**
         * Switch type of third, reload searchThird() in refs component only if pending input in name input field.
         */
        switchFomField() {
            this.$store.dispatch(`${this.current}/resetCompany`).then(() => {
                this.relatedThird = this.relatedThird === 'company' ? 'individual' : 'company';
                this.$store.commit(`${this.current}/setThirdType`, this.relatedThird);

                //reload the search company per name in dropdown component
                if (!_.isNil(this.$refs.formFieldsThirdToAdd.$refs.dropdownSearchThird)) {
                    this.$refs.formFieldsThirdToAdd.$refs.dropdownSearchThird.searchThird();
                }
            });
        },
        catchErrors(err) {
            this.error = err ? err : [{}];
        },
    },
};
</script>

<style>
.third-opportunities-form .third-form {
    min-height: 1315px;
}
</style>
